<template>
    <console-layout width="100%" max-width="1560">
        <console-title>
            <span>반품관리</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row align="center">
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[0]" label="주문일자" persistent-placeholder hide-details />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[1]" label="주문일자" persistent-placeholder hide-details />
                </v-col>
            </v-row>
            <v-row class="mt-2">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.status" :items="statusKeys" item-text="text" item-value="value" label="주문상태" persistent-placeholder hide-details />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-layout class="align-center">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span>
                    <v-btn color="white" elevation="1" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                    </v-btn>
                </span>
            </v-layout>
    
            <v-data-table v-model="selected" :items="purchases" item-key="_id" :headers="purchasesHeaders" show-select hide-default-footer disable-pagination disable-sort class="mt-2 elevation-1">
                <template #[`item.data-table-select`]="{item, isSelected, select}">
                    <v-simple-checkbox :value="isSelected" :disabled="item.status == `반품완료` || item.status == `반품반려`" @input="isSelected ? selected.splice(selected.indexOf(item), 1) : select($event)" />
                </template>

                <template #[`item.quantity`]="{item}">
                    <span>{{ item.quantity.format() }}개</span>
                </template>

                <template #[`item.product`]="{item}">
                    <v-layout class="align-center">
                        <v-img :src="item?.product?.thumb" max-width="96" max-height="96" contain/>
                        <div class="pl-4">
                            <div><b>{{ item?.product?.name }}</b></div>
                            <div>{{ item?.product?.salePrice.format() }}원</div>
                            <div v-if="item?.product?.type == 'option'">[{{ item?.product?.optionalNames.toString() }}] : {{ item?.product?.optionalValues.toString() }}</div>
                            <div v-if="item?.product?.type == 'addition'">[{{ item?.product?.additionalName.toString() }}] : {{ item?.product?.additionalValue.toString() }}</div>
                        </div>
                    </v-layout>
                </template>

                <template #[`item.order.buyer`]="{item}">
                    <div>
                        <div>{{ item.order.buyer.name }} ({{ item.order.buyer.username }})</div>
                        <div>{{ item.order.buyer.phone }}</div>
                        <div>{{ item.order.buyer.email }}</div>
                    </div>
                </template>

                <template #[`item.order.receiver`]="{item}">
                    <div>
                        <div>{{ item.order.receiver.name }}</div>
                        <div>{{ item.order.receiver.phone }}</div>
                        <div>{{ item.order.receiver.email }}</div>
                    </div>
                </template>

                <template #[`item.order.shippingAddress`]="{item}">
                    <div>
                        <div>[{{ item.order.shippingAddress.postcode }}]</div>
                        <div>{{ item.order.shippingAddress.address1 }}</div>
                        <div>{{ item.order.shippingAddress.address2 }}</div>
                    </div>
                </template>

                <template #[`item.shippingInfo`]="{item}">
                    <div>
                        <div>{{ item.shippingInfo.method }}</div>
                        <div>{{ item.shippingInfo.invoiceNumber }}</div>
                        <div>{{ couriers.find(courier => courier.code == item.shippingInfo.courier)?.text }}</div>
                    </div>
                </template>
                <template #[`item.order.totalAmount`]="{item}">
                    <span>{{ item.order.totalAmount.format() }}원</span>
                </template>
                <template #[`item.createdAt`]="{item}">
                    <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                </template>
                <template #[`item.order`]="{item}">
                    <span>{{ paymentWay(item)}}</span>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-4" @input="search(true)"/>
    
            <v-card class="mt-4">
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-sheet width="100">수거정보</v-sheet>
                        </v-col>
                        <v-col>
                            <v-btn outlined color="primary" @click="collecting()">반품 수거처리</v-btn>
                            <v-btn outlined color="primary" class="ml-2" @click="collected()">수거 완료처리</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="my-2"/>
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-sheet width="100">반품처리</v-sheet>
                        </v-col>
                        <v-col>
                            <v-btn outlined color="primary" @click="reject()">반품 거부처리</v-btn>
                            <v-btn outlined color="primary" class="ml-2" @click="complete()">반품 완료처리</v-btn>
                            <!-- <v-btn outlined color="primary" class="ml-2" @click="exchange()">교환으로 변경</v-btn> -->
                        </v-col>
                    </v-row>
                    <v-divider class="my-2"/>
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-sheet width="100">구매확정</v-sheet>
                        </v-col>
                        <v-col>
                            <v-btn outlined color="primary" @click="confirmation()">구매확정</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </console-body>

        <exchange-dialog ref="exchangeDialog" />

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ExchangeDialog from "@/components/console/shop/purchase/exchange-dialog.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";
import couriers from "@/assets/data/couriers.json";

export default {
    components: {
        ExchangeDialog,
        VDateField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                createdAt: [ this.$route.query.createdAt?.[0] || '', this.$route.query.createdAt?.[1] || '' ],
                status: this.$route.query.status ? [...this.$route.query.status.toString().split(",")] : ["반품요청", "반품반려", "반품수거중", "반품수거완료", "반품완료"],
                code: this.$route.query.code
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            selected: [],
            summary: { totalCount: 0 },
            purchases: [],
            purchasesHeaders: [
                { text: "주문일자", value: "createdAt", align: "center", width: 120 },
                { text: "주문상태", value: "status", align: "center", width: 90 },
                { text: "결제상태", value: "paymentStatus", align: "center", width: 90 },
                { text: "주문번호", value: "order.orderNo", align: "center", width: 100 },
                { text: "구매번호", value: "purchaseNo", align: "center", width: 100 },
                { text: "구매상품", value: "product", align: "center", width: 250 },
                // { text: "구매옵션", value: "option-addition", align: "center", width: 200 },
                { text: "구매수량", value: "quantity", align: "center", width: 100 },
                { text: "결제방법", value: "order", align: "center", width: 100 },
                { text: "결제금액", value: "order.totalAmount", align: "center", width: 100 },
                { text: "구매자", value: "order.buyer", align: "center", width: 100 },
                { text: "수취인", value: "order.receiver", align: "center", width: 100 },
                { text: "배송지", value: "order.shippingAddress", align: "center", width: 150 },
                { text: "송장정보", value: "shippingInfo", align: "center", width: 150 },
                { text: "반품사유", value: "reason", align: "center", width: 200 },
                { text: "반품요청내용", value: "demand", align: "center", width: 200 },
                { text: "선물상태", value: "giftStatus", align: "center", width: 90 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "주문번호", value: "order.orderNo" },
                { text: "구매번호", value: "purchaseNo" },
                { text: "구매자 이름", value: "order.buyer.name" },
                { text: "구매자 아이디", value: "order.buyer.username" },
                { text: "구매자 연락처", value: "order.buyer.phone" },
                { text: "구매자 이메일", value: "order.buyer.email" },
                { text: "수취인 이름", value: "order.receiver.name" },
                { text: "수취인 연락처", value: "order.receiver.phone" },
                { text: "수취인 이메일", value: "order.receiver.email" },
            ],
            statusKeys: [
                { text: ":: 전체 ::", value: ["반품요청", "반품반려", "반품수거중", "반품수거완료", "반품완료"] },
                { text: "반품요청", value: "반품요청" },
                { text: "반품반려", value: "반품반려" },
                { text: "반품수거중", value: "반품수거중" },
                { text: "반품수거완료", value: "반품수거완료" },
                { text: "반품완료", value: "반품완료" },
            ],

            couriers
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, purchases } = await api.console.shop.purchases.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.purchases = purchases;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        // 반품 수거처리
        async collecting(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("수거 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "반품수거중"
                    });
                }
                alert("수거 처리되었습니다");
                this.search(false);
            }
        },

        // 수거 완료처리
        async collected(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("수거완료 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "반품수거완료"
                    });
                }
                alert("수거완료 처리되었습니다");
                this.search(false);
            }
        },

        // 반품 거부처리
        async reject(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("반품거부 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "반품반려",
                        purchaseStatus: "구매확정대상",
                    });
                }
                alert("반품거부 처리되었습니다");
                this.search(false);
            }
        },

        // 반품 완료처리
        async complete(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("반품완료 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        _product: purchase.product._id ,
                        status: "반품완료",
                        paymentStatus: "환불완료",
                        quantity: purchase.quantity
                    });
                }
                alert("반품완료 처리되었습니다");
                this.search(false);
                this.selected = [];
            }
        },

        // 반품반려 후 구매확정
        async confirmation(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("구매확정 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        purchaseStatus: "반품반려구매확정",
                    });
                }
                alert("구매확정 처리되었습니다");
                this.search(false);
                this.selected = [];
            }
        },

        // 교환으로 변경
        exchange(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }

            this.$refs.exchangeDialog.$off();
            this.$refs.exchangeDialog.$on("input", async ({ reason, demand }) => {
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "교환요청",
                        purchaseStatus: "구매확정보류",
                        reason,
                        demand
                    });
                }
                alert("교환요청 처리되었습니다");
                this.search(false);
            });
            this.$refs.exchangeDialog.open();
        },

        async excel(){
            let { purchases } = await api.console.shop.purchases.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            purchases.forEach(purchase => {
                rows.push({
                    "주문일자": this.$dayjs(purchase?.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    "주문상태": purchase?.status,
                    "결제상태": purchase?.paymentStatus,
                    "주문번호": purchase?.order?.orderNo,
                    "구매번호": purchase?.purchaseNo,
                    "구매상품": purchase?.product?.name,
                    "구매옵션": (purchase?.product?.type == "option" || purchase?.product?.type == "addition") ? `[${purchase.product.optionalNames?.toString?.() || purchase.product.additionalName }] : ${purchase.product.optionalValues?.toString?.() || purchase.product.additionalValue }` : "",
                    "구매수량": purchase?.quantity?.format?.(),
                    "결제방법": this.paymentWay(purchase),
                    "결제금액": purchase?.order?.totalAmount?.format?.(),
                    "구매자 이름": purchase?.order?.buyer?.name,
                    "구매자 아이디": purchase?.order?.buyer?.username,
                    "구매자 연락처": purchase?.order?.buyer?.phone,
                    "구매자 이메일": purchase?.order?.buyer?.email,
                    "수취인 이름": purchase?.order?.receiver?.name,
                    "수취인 연락처": purchase?.order?.receiver?.phone,
                    "수취인 이메일": purchase?.order?.receiver?.email,
                    "배송지": purchase?.order?.shippingAddress?.postcode ? `[${purchase?.order?.shippingAddress?.postcode}] ${purchase?.order?.shippingAddress?.address1} ${purchase?.order?.shippingAddress?.address2}` : '-',
                    "배송방법": purchase?.shippingInfo?.method || '-',
                    "운송장번호": purchase?.shippingInfo?.invoiceNumber || '-',
                    "택배사": couriers.find(courier => courier.code == purchase?.shippingInfo?.courier)?.text || '-',
                    "반품사유": purchase?.reason,
                    "반품요청내용": purchase?.demand,
                    "선물상태": purchase?.giftStatus,
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "반품내역");
            XLSX.writeFile(workbook, "반품내역.xlsx");
        },
        paymentWay(item){
            let str = ""
            if(item?.order?.type === 'exchange') return '모바일 도서교환권 사용'
            if(item?.order?.cashAmount && item?.order?.pointAmount && !item?.order?.paymentAmount) str =  '캐시 & 포인트 결제'
            if(item?.order?.cashAmount && !item?.order?.pointAmount && !item?.order?.paymentAmount) str =  '캐시 결제'
            if(!item?.order?.cashAmount && item?.order?.pointAmount && !item?.order?.paymentAmount) str =  '포인트 결제'
            if(!item?.order?.cashAmount && !item?.order?.pointAmount && item?.order?.paymentAmount) str =  '신용카드 결제'
            if(!item?.order?.cashAmount && item?.order?.pointAmount && item?.order?.paymentAmount) str =  '신용카드 & 포인트 결제'
            if(item?.order?.cashAmount && !item?.order?.pointAmount && item?.order?.paymentAmount) str =  '신용카드 & 캐시 결제'
            if(item?.order?.cashAmount && item?.order?.pointAmount && item?.order?.paymentAmount) str =  '신용카드 & 캐시 & 포인트 결제'
            return str
        },
    },
    watch: {
        selected(){
            if(this.selected.find(purchase => purchase.status == "반품완료")) this.selected = this.selected.filter(purchase => purchase.status != "반품완료");
        }
    }
}
</script>